import _ from 'lodash';
import React from 'react';
import {
  BusinessUnitFilter,
  DisciplineFilter,
  FiltersGroup,
  LocationFilter,
  PlaceholderStatusFilter,
  PracticeFilter,
  SkillFilter,
} from '~/components/filters';
import { useFeatures } from '~/hooks';

export default function PlaceholderFiltersGroup({ filters, onChange }) {
  const features = useFeatures();

  return (
    <FiltersGroup
      label="Placeholder Filters"
      filters={[
        filters.placeholderPractices,
        filters.placeholderBusinessUnits,
        filters.placeholderDisciplines,
        filters.placeholderLocations,
        filters.placeholderSkills,
        filters.placeholderStatusId,
      ]}>
      {features.practices && _.has(filters, 'placeholderPractices') && (
        <PracticeFilter
          placeholder="Placeholder Practice"
          value={filters.placeholderPractices}
          onChange={({ target: { value } }) => onChange({ placeholderPractices: value })}
        />
      )}

      {features.businessUnits && _.has(filters, 'placeholderBusinessUnits') && (
        <BusinessUnitFilter
          placeholder="Placeholder Business Unit"
          value={filters.placeholderBusinessUnits}
          onChange={({ target: { value } }) => onChange({ placeholderBusinessUnits: value })}
        />
      )}

      {features.disciplines && _.has(filters, 'placeholderDisciplines') && (
        <DisciplineFilter
          placeholder="Placeholder Discipline"
          value={filters.placeholderDisciplines}
          onChange={({ target: { value } }) => onChange({ placeholderDisciplines: value })}
        />
      )}

      {_.has(filters, 'placeholderLocations') && (
        <LocationFilter
          placeholder="Placeholder Location"
          value={filters.placeholderLocations}
          onChange={({ target: { value } }) => onChange({ placeholderLocations: value })}
        />
      )}

      {_.has(filters, 'placeholderSkills') && (
        <SkillFilter
          placeholder="Placeholder Skills"
          value={filters.placeholderSkills}
          onChange={({ target: { value } }) => onChange({ placeholderSkills: value })}
        />
      )}

      {_.has(filters, 'placeholderStatusId') && (
        <PlaceholderStatusFilter
          value={filters.placeholderStatusId}
          onChange={({ target: { value } }) => onChange({ placeholderStatusId: value })}
        />
      )}
    </FiltersGroup>
  );
}
